import { render, staticRenderFns } from "./LoadingBlock.vue?vue&type=template&id=43a66306&"
import script from "./LoadingBlock.vue?vue&type=script&lang=ts&"
export * from "./LoadingBlock.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports